import React from "react";
import "./index.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { ToastProvider } from "./providers";
import { RouterProvider } from "react-router-dom";
import router from "./routes/AuthRoutes";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/react-query";
import { ColorSchemeScript, MantineProvider } from "@mantine/core";
import appTheme from "./theme";
import { ErrorBoundary } from "./components/ui/ErrorBoundary/ErrorBoundary";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ColorSchemeScript defaultColorScheme="light" />
      <MantineProvider theme={appTheme}>
        <ToastProvider>
          <ErrorBoundary>
            <div className="flex h-screen bg-gray-50">
              <RouterProvider router={router} />
            </div>
          </ErrorBoundary>
          <ReactQueryDevtools initialIsOpen={false} />
        </ToastProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
}

export default App;
